export default "__VITE_ASSET__1uEfxDNw__"